import {OrderItem} from './OrderItem';
import {ReviewItem} from './ReviewItem';
import {MenuListItem} from './MenuListItem';
import {FavoriteItem} from './FavoriteItem';
import {PromocodeItem} from './PromocodeItem';
import {RecomendedItem} from './RecomendedItem';
import {HomeReviewItem} from './HomeReviewItem';

import {MySonsItem} from './MySonsItem';
import {ArticlesItem} from './ArticlesItem';
import {ActivitiesItem} from './ActivitiesItem';
import {FeeKindDetailsItem} from './FeeKindDetailsItem';
import {PartnersItem} from './PartnersItem';
import {ExtraCurricularItem} from './ExtraCurricularItem';
import {AcademyItem} from './AcademyItem';
import {CreationItem} from './CreationItem';
import {CamperVansItem} from './CamperVansItem';
import {FeedsItem} from './FeedsItem';
import {HistoryItem} from './HistoryItem';
import {LocationsItem} from './LocationsItem';

export const items = {
  OrderItem,
  ReviewItem,
  FavoriteItem,
  MenuListItem,
  PromocodeItem,
  RecomendedItem,
  HomeReviewItem,
  MySonsItem,
  ArticlesItem,
  ActivitiesItem,
  FeeKindDetailsItem,
  PartnersItem,
  ExtraCurricularItem,
  AcademyItem,
  CreationItem,
  CamperVansItem,
  FeedsItem,
  HistoryItem,
  LocationsItem
};
